<template>
  <div class="track-history">
    <Card :bordered="false">
      <Row :gutter="16">
        <Col span="5">
        <!-- 版本 -->
        <div class="edition">
          <Card>
            <Row
              class="text-row"
              v-for="(item,key) in version"
              :key="key"
            >
              <Col
                span="24"
                class="text-key"
              >{{item.name}}</Col>
              <Col
                span="24"
                class="text-value"
              >{{item.value}}
              </Col>
            </Row>
          </Card>
        </div>

        <!-- 预警 -->
        <div class="early-warning">
          <Card>
            <div
              v-for="(item,key) in notice"
              :key="key"
            >
              <Poptip
                trigger="hover"
                :title="`${langMap.warningTime[lang]}：${item.timestamp | formatDateTime}`"
                :content="`${langMap.warningMessage[lang]}：${item.msg}`"
              >
                <div class="item">
                  <p>{{langMap.warningMessage[lang]}}：</p>
                  <span class="text">{{item.msg}}</span>
                  <span
                    v-if="item.type===1"
                    class="level"
                  >{{langMap.high[lang]}}</span>
                  <span
                    v-if="item.type===0"
                    class="low"
                  >{{langMap.low[lang]}}</span>
                </div>
              </Poptip>
            </div>
          </Card>
        </div>
        </Col>

        <Col span="14">
        <!-- 地图 :is="defaultMap"-->
        <component
          is="leaflet"
          ref="mapCase"
          :areaColor="areaColorList"
          :trackColor="'#596164'"
        >
          <div
            id="track_map_id"
            ref="map"
            class="map_div"
          ></div>
        </component>
        </Col>

        <Col span="5">
        <!-- 状态 -->
        <div class="robot-data">
          <Card>
            <Row
              class="text-row"
              v-for="(item,key) in status"
              :key="key"
            >
              <Col
                span="24"
                class="text-key"
              >{{item.name}}</Col>
              <Col
                span="24"
                class="text-value"
              >{{item.value}}
              </Col>
            </Row>
          </Card>
        </div>
        </Col>
      </Row>

      <Row>
        <Col span="24">
        <div class="bottom">
          <!-- 进度条 -->
          <Slider
            class="progress-bar"
            @on-change="valueChange"
            v-model="value"
            :tip-format="format"
            :max=totalTime
          ></Slider>

          <div class="status">
            <ButtonGroup>
              <Button
                icon="ios-pause"
                @click="broadcastClick()"
              >{{langMap.play[lang]}}</Button>
              <Button
                icon="ios-play"
                @click="ceaseClick()"
              >{{langMap.pause[lang]}}</Button>

              <Button>{{langMap.totalDuration[lang]}}：{{totalTime}}s</Button>

              <Select
                v-model="num"
                style="width:80px"
              >
                <Option value=1>1 {{langMap.playbackSpeed[lang]}}</Option>
                <Option value=0.8>1.5 {{langMap.playbackSpeed[lang]}}</Option>
                <Option value=0.5>2 {{langMap.playbackSpeed[lang]}}</Option>
              </Select>
            </ButtonGroup>

          </div>

          <div class="time-1">{{value}}s</div>
        </div>
        </Col>
      </Row>
    </Card>

  </div>
</template>

<script>
import leaflet from "./mapUnit/leaflet.vue";

import moment from "moment";
import api from "../../../api";
import { formatDate } from "./formatDate";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
let centerState = false;
let mapCase = null;

export default {
  components: { leaflet},
  props: {
    // 绘制区域用的颜色集
    areaColor: {
      type: Array,
      default: () => ["", "", ""]
    },
    // 历史路径颜色
    trackColor: {
      type: String,
      default: "#AB8B54"
    }
  },
  data() {
    return {
      langMap:langMap,
      area: [],
      name: "",
      sleep: false,
      flag: false,
      start: "",
      num: "1",
      timeList: [],
      value: 0,
      id: "",
      robotId: "",
      totalTime: 0, //总时间
      map: {},
      robotsLayer: [],
      version: {},
      status: {},
      movement: [],
      notice: [],
      level: "高",
      low: "低",
    };
  },
  filters: {
    formatDateTime(date) {
      return formatDate(date);
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      areaColorList: state => state.app.mapAreaColor
    }),
    col () {
      return [
        {
          title: langMap.warningTime[this.lang],
          width: 160,
          key: "timestamp",
          render(h, params) {
            return h(
              "span",
              {},
              moment(params.row.timestamp).format("yyyy-MM-DD HH:mm:ss")
            );
          }
        },
        {
          title: langMap.type[this.lang],
          width: 120,
          key: "type",
          render: (h, params) => {
            let text = "";
            if (params.row.type === 0) {
              text = langMap.secondaryWarning[this.lang];
            } else {
              text = langMap.primaryWarning[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.warningMessage[this.lang],
          key: "msg"
        }
      ]
    }
  },
  methods: {
    formatDate(val) {
      return formatDate(val);
    },
    //时间
    getTimeSlot() {
      api
        .getData(
          "notice-server/data/times/" +
            this.id +
            "?robotId=" +
            (this.robotId || ""),
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            if (res.data.length > 0) {
              this.start = res.data[0];
            }

            this.timeList = res.data;
            this.totalTime = res.data.length;
          }
        });
    },
    async play() {
      while (this.flag && this.value <= this.totalTime) {
        this.getTrackData();
        let ret = await this.sleepFun();
        this.value = this.value + 1;
      }
    },
    // 获取历史数据
    getTrackData() {
      let end = this.timeList[this.value];
      if (!end) {
        return;
      }
      let param = end;
      if (this.sleep) {
        param = this.start + "," + param;
      }
      api
        .getData(
          "notice-server/data/history/" +
            this.id +
            "?robotId=" +
            (this.robotId || "") +
            "&times=" +
            param,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.handlerData(res, end);
          }
        });
    },
    handlerData(res, end) {
      if (!res.data) return;
      if (this.sleep) {
        this.$nextTick(() => {
          this.movement = [];
          this.status = {};
          this.notice = [];
          this.version = {};
        });
      }

      for (const key in res.data) {
        let data = res.data[key];
        let type;
        let value;
        for (const k in data) {
          type = k;
          value = data[k][0];
          switch (type) {
            case "status:":
              this.status = value;
              break;
            case "movement:":
              this.movement.push(value);
              break;
            case "version:":
              this.version = value;
              break;
            case "notice:":
              this.notice.push(value);
              break;
          }
        }

        if (key == end) {
          this.showMap();
        }
      }
      this.sleep = false;
    },

    // 地图
    showMap() {
      let d,
        lastPosition = [];
      if (this.movement.length > 0) {
        d = this.movement[this.movement.length - 1];
        lastPosition = [d.var1, d.var2];
      }

      let robot = {
        id: this.robotId,
        name: this.name,
        lastPosition: lastPosition,
        status: 1,
        hisPoints: this.movement,
        statusData: this.status,
        movementData: d
      };

      mapCase.drawJobVision(robot, this.robotsLayer);
      // 设置中心点
      if (centerState) return;
      const _point = robot.lastPosition;
      mapCase.moveToCenter(_point);
      centerState = true;
    },

    // 加载区域
    loadAreas() {
      api.getData("task-server/fence/list", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tips[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data && res.data.length > 0) {
            // 区域绘制
            mapCase.initTargetArea(res.data);

          }
        }
      });
    },

    broadcastClick() {
      // console.log("播放");
      // value=当前播放时间/总时间*100
      this.flag = true;
      this.play();
    },
    sleepFun(logStr) {
      return new Promise(res => {
        return setTimeout(() => {
          res(logStr);
        }, 1000 * this.num);
      });
    },
    ceaseClick() {
      this.flag = false;
    },
    valueChange(value) {
      this.sleep = true;
    },
    format(val) {
      return `${langMap.progress[this.lang]}: ${val}s`;
    }
  },
  mounted() {
    //初始化地图、初始化地图组件
    this.$nextTick(() => {
      mapCase = this.$refs.mapCase;
      mapCase.initMap();
      this.loadAreas();
    });
  },
  created() {
    this.id = this.$route.query.id;
    this.robotId = this.$route.query.robotId;
    this.name = this.$route.query.name;
    this.getTimeSlot();
  },

  beforeDestroy() {
    this.flag = false;
  }
};
</script>

<style lang="less" scoped>
.track-history {
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  /deep/ .ivu-card {
    width: 100%;
    height: 100%;
  }

  /deep/ .ivu-card-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.edition {
  height: 272px;
  margin-bottom: 10px;
  padding: 5px;

  // &::-webkit-scrollbar {
  //   display: none;
  // }
}

.early-warning {
  height: 460px;
  padding: 5px;

  /deep/.ivu-card-body {
    overflow: hidden;
    overflow-y: scroll;
  }

  /deep/.ivu-poptip {
    width: 100%;

    .ivu-poptip-rel {
      width: 100%;
    }
  }

  .item {
    display: flex;
    align-items: center;
    width: 100%;
    color: #000;
    font-size: 12px;
    margin: 5px 0;
    cursor: pointer;
    border: 1px solid #e8eaec;
    padding: 3px;
    .text {
      margin-left: 5px;
    }

    .level {
      width: 16px;
      height: 16px;
      padding: 2px 2px -1px;
      text-align: center;
      background-color: red;
      color: #fff;
      margin-left: 3px;
      border-radius: 3px;
    }
    .low {
      width: 16px;
      height: 16px;
      padding: 2px 2px -1px;
      text-align: center;
      background-color: rgb(255, 123, 0);
      color: #fff;
      margin-left: 3px;
      border-radius: 3px;
    }
  }
}

.robot-data {
  height: 100%;
  border-radius: 10px;
  padding: 5px;
  overflow-x: hidden;
}

.bottom {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 20px;

  .progress-bar {
    width: 100%;
    height: 100%;

    /deep/ .ivu-slider-wrap {
      height: 10px;
      z-index: 999;
    }

    /deep/ .ivu-slider-button {
      width: 18px;
      height: 18px;
    }

    /deep/ .ivu-slider-bar {
      height: 10px;
    }
  }

  .status {
    margin-left: 20px;

    .ivu-btn-group {
      margin: 0 3px;
      display: flex;
      // color: cornflowerblue;
    }
  }

  .time-1 {
    position: absolute;
    left: 16px;
    top: 28px;
  }
  .time-2 {
    position: absolute;
    right: 194px;
    top: 28px;
  }
}

.text-key {
  color: #000;
  font-size: 12px;
  flex-wrap: nowrap;
  width: 50%;
}
.text-value {
  color: #000;
  font-size: 12px;
}
.text-row {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.report {
  width: 100%;
  overflow: hidden;
  overflow-x: scroll;
}

.map_div {
  height: 734px;
}

.ivu-table .first-level-warning tr {
  background-color: #2db7f5;
  color: #fff;
}

.ivu-table .two-level-warning tr {
  background-color: #ff6600;
  color: #fff;
}

/deep/.ivu-col-span-5 {
  height: 100%;
}

/ddep/.ivu-col {
  padding-left: 5px;
  padding-right: 5px;
}

/deep/.ivu-card-body {
  padding: 5px;
}
</style>
